import React, { useState } from "react";
import {
  Box,
  HeadingStyled,
  LabelStyled,
} from "../../../components/styled/Elements";
import { StepsWrapper } from "./Styled";
import { Col, Row } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useTranslation } from "react-i18next";
import { urlRegex } from "../../../utils";

export const Step4 = ({ register, control, errors }) => {
  const { t } = useTranslation();

  return (
    <>
      <StepsWrapper>
        <HeadingStyled className="stepsMainTitle" size="24px">
          {t("WebSocialMediaPresence")}
        </HeadingStyled>
        <Box className="stepFormContainer">
          <Row className="mt-3">
            <Col md={6}>
              <ValidatedInput
                name="website_url"
                type="input"
                fieldType="text"
                placeholder="WebsiteURL"
                label="WebsiteURL"
                className=""
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                  pattern: {
                    value: urlRegex,
                    message: t("please_enter_valid_url"),
                  },
                }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="facebook_profile_link"
                type="input"
                fieldType="text"
                placeholder="FacebookProfileLink"
                label="FacebookProfile"
                className="combined"
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                  pattern: {
                    value: urlRegex,
                    message: t("please_enter_valid_url"),
                  },
                }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="instagram_profile_link"
                type="input"
                fieldType="text"
                placeholder="InstagramProfileLink"
                label="InstagramProfileLink"
                className=""
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                  pattern: {
                    value: urlRegex,
                    message: t("please_enter_valid_url"),
                  },
                }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="linkedin_profile_link"
                type="input"
                fieldType="text"
                placeholder="LinkedInProfileLink"
                label="LinkedInProfileLink"
                className=""
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                  pattern: {
                    value: urlRegex,
                    message: t("please_enter_valid_url"),
                  },
                }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="x_profile_link"
                type="input"
                fieldType="text"
                placeholder="XProfileLink"
                label="XProfileLink"
                className=""
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                  pattern: {
                    value: urlRegex,
                    message: t("please_enter_valid_url"),
                  },
                }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="youtube_channel_link"
                type="input"
                fieldType="text"
                placeholder="YouTubeChannelLink"
                label="YouTubeChannelLink"
                className=""
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                  pattern: {
                    value: urlRegex,
                    message: t("please_enter_valid_url"),
                  },
                }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="one_day_profile_link"
                type="input"
                fieldType="text"
                placeholder="one_day_profile_link"
                label="one_day_profile_link"
                className=""
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                  pattern: {
                    value: urlRegex,
                    message: t("please_enter_valid_url"),
                  },
                }}
              />
            </Col>
          </Row>
        </Box>
      </StepsWrapper>
    </>
  );
};
